import { isAxiosError } from "axios";

import api from "@/services/api";

export interface ConsentScope {
  id: string;
  label: string;
  warning: string;
}

export interface ConsentDetails {
  client_name: string;
  redirect_host: string;
  scopes: ConsentScope[];
}

/** The scope that confirms approvals for the user. */
export const DECISIONS_SCOPE = "decisions:write";
/** The scope that corrects an application's analysis (how its transactions count). */
export const ANALYSIS_SCOPE = "analysis:write";
/** The scopes the user opts into one by one: never pre-selected. */
export const OPT_IN_SCOPES: readonly string[] = [DECISIONS_SCOPE, ANALYSIS_SCOPE];

/** The API's own sentence for a failed call, or a fallback. */
export function consentErrorMessage(error: unknown, fallback: string): string {
  if (isAxiosError(error)) {
    if (error.response?.status === 403) return "The assistant is not available for this account.";
    const message = (error.response?.data as { message?: unknown } | undefined)?.message;
    if (typeof message === "string" && message) return message;
  }
  return fallback;
}

/** An MCP app (claude.ai, ChatGPT) asking to use the assistant as this user: GET the request, POST the answer. */
export const agentOAuthService = {
  getConsent: (request: string) =>
    api.get<ConsentDetails>("/agent/oauth/consent/", { params: { request } }).then((r) => r.data),

  decide: (request: string, decision: "allow" | "deny", scopes: string[]) =>
    api
      .post<{ redirect_to: string }>("/agent/oauth/consent/", { request, decision, scopes })
      .then((r) => r.data.redirect_to),
};
